import React, { useCallback, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import { FormattedMessage } from 'react-intl';
import { messages } from './messages';
import { ExpandingTextField } from './ExpandingTextField';

const useStyles = makeStyles(() => ({
  paperWidthXs: {
    maxWidth: '260px',
  },
}));

export const CoveredDialog = ({ open, onClose, medication, handleChange }) => {
  const classes = useStyles();
  const [reason, setReason] = useState(medication.notcoveredreason || '');

  useEffect(() => {
    if (open) {
      setReason(medication.notcoveredreason || '');
    }
    // Reload the saved reason only when the dialog opens. A medication
    // refresh while it stays open must not clear in-progress text.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const saveReason = useCallback(() => {
    if (reason !== '') {
      handleChange(medication, 'notcoveredreason', {
        coveredbyhospice: 'false',
        notcoveredreason: reason,
      });
    }
    onClose();
  }, [handleChange, medication, onClose, reason]);

  return (
    <Dialog
      onClose={onClose}
      disableBackdropClick
      aria-labelledby="covered-status-selection"
      open={open}
      maxWidth="xs"
      classes={{ paperWidthXs: classes.paperWidthXs }}
    >
      <DialogTitle id="covered-dialog-title" disableTypography>
        {medication.drugdescription}
      </DialogTitle>
      <DialogContent dividers>
        <div>
          <ExpandingTextField
            value={reason}
            onValueChange={setReason}
            onEnter={saveReason}
            label={<FormattedMessage {...messages.reasonNotCovered} />}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          color="primary"
          variant="outlined"
          onClick={onClose}
        >
          <FormattedMessage {...messages.cancelBTN} />
        </Button>
        <Button
          size="small"
          color="primary"
          variant="outlined"
          disabled={reason === ''}
          onClick={saveReason}
        >
          <FormattedMessage {...messages.saveBTN} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
